import { Basic } from "../basic";
import i18next from "i18next";

const locale = {
    days: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
    daysShort: ['Вос', 'Пон', 'Вто', 'Сре', 'Чет', 'Пят', 'Суб'],
    daysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
    monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    today: 'Сегодня',
    cancel: 'Отмена',
    apply: 'Применить',
    dateFormat: 'dd.MM.yyyy',
    timeFormat: 'HH:mm',
    firstDay: 1
};

const template = () => `
    <style>
        :host {
            display: inline-block;
            border: 1px solid #ccc;
            border-radius: 6px;
            background-color: #fff;
        }

        :host(:focus-within) {
            border-color: #007bff !important;
        }

        :host(:focus-within) #calendar-input {
            background: url("/styles/Frame1997.svg") no-repeat right 8px center;
            background-size: 16px;
        }

        #calendar-input {
            border: none !important;
            outline: none !important;
            width: 100%;
            height: 100%;
            border-radius: 6px;
            background: url("/styles/Frame1996.svg") no-repeat right 8px center;
            background-size: 16px;
            padding-right: 25px;
        }
        
        .tooltip-wrap {
            color: red;
        }
    </style>
    <input id="calendar-input" type="text"/>
`;

/**
 * @class MSCalendarInput
 * @extends Basic
 * @classdesc Календарь
 */
export class MSCalendarInput extends Basic {
    static get observedAttributes() {
        return super.observedAttributes.concat([
         "datetimetype",
         "datetime",
         "fontname",
         "fontsize",
         "horizontalaligntext",
         "fontitalic",
         "fontbold",
         "underline",
         "textcolor",
         "mousecursorkind"
        ]);
    }
    constructor() {
        super();
        const shadowRoot = this.attachShadow({ mode: 'open' });
        shadowRoot.innerHTML = template();
        this.style.display = "inline-block";
        this.inputElem = this.shadowRoot.getElementById("calendar-input");
        this.inputElem.style.fontFamily = "Tahoma";
        this.inputElem.style.fontSize = 12;
        this.inputElem.style.textAlign = "start";
        this.inputElem.setAttribute("readonly", "true")
        this.originalValue = this.getCurrentDateTime();
        this.inputElem.value = this.originalValue;
        this.initDatepicker();
        this.handleClick = this.handleClick.bind(this);
        this.inputElem.addEventListener("click" , this.handleClick);
    }

    handleClick() {
        this.updateButtons()
    }

    get mousecursorkind() {
        return this._mousecursorkind || 'default';
    }
    set mousecursorkind(value) {
        this._mousecursorkind = value;
        this.inputElem.style.cursor = this.getCursor(value);
    }

    get textcolor() {
        return this._itemtextcolor || '#000';
    }
    set textcolor(value) {
        this._itemtextcolor = value;
        value = this.tryToGetUserColor(value);
        this.inputElem.style.color = value;
    }

    get underline() {
        return this._fontunderlined ?? false;
    }
    set underline(value) {
        this._fontunderlined = this._toBool(value);
        const textDecoration = this._fontunderlined ? "underline" : "none";
        this.inputElem.style.textDecoration = textDecoration;
    }

    get fontbold() {
        return this._bold ?? false;
    }
    set fontbold(value) {
        this._bold = this._toBool(value);
        const fontWeight = this._bold ? "bold" : "normal";
        this.inputElem.style.fontWeight = fontWeight;
    }

    get fontitalic() {
        return this._italic ?? false;
    }
    set fontitalic(value) {
        this._italic = this._toBool(value);
        const fontStyle = this._italic ? "italic" : "normal";
        this.inputElem.style.fontStyle = fontStyle;
    }

    get horizontalaligntext() {
        return this._horizontalaligntext;
    }

    set horizontalaligntext(value) {
        this._horizontalaligntext = value;
        this.inputElem.style.textAlign = window._enums.AlignText[value];
    }

    get fontsize() {
        return this._fontsize;
    }

    set fontsize(value) {
        this._fontsize = value;
        this.inputElem.style.fontSize = this._fontsize;
    }

    get fontname() {
        return this._fontname;
    }

    set fontname(value) {
        this._fontname = value;
        this.inputElem.style.fontFamily = this._fontname;
    }

    _update() {
        if (this._datetime === undefined) {
            this._datetime = new Date().getTime();            
            this.inputElem.value = this.getCurrentDateTime();
            return;        
        }
        if (this._datetime === '0') {
            this.inputElem.value = this.getCurrentDateTime();            
            return;
        }
        let dt = new Date(Number(this._datetime));        
        if (isNaN(dt.valueOf())) dt = new Date();
        this.inputElem.value = this.formatDate(dt);    
    }

    saveClick() {
        let selectedDate = this.dp.selectedDates[0] 
        if (!selectedDate) return;
    
        let formattedDate;
        let timestamp;
        formattedDate = this.formatDate(selectedDate)
        timestamp = selectedDate.getTime();
        this.SetParameter("datetime", timestamp, this.force);    
        this.inputElem.value = formattedDate;
    }

    formatDate(date) {
        if (this._datetimetype === 0) {
            return date.toLocaleDateString("ru-RU", { 
                day: "2-digit", 
                month: "2-digit", 
                year: "numeric" 
            });
        }
        if (this._datetimetype === 2) {
            return `${date.toLocaleTimeString("ru-RU", { 
                hour: "2-digit", 
                minute: "2-digit" 
            })}, ${date.toLocaleDateString("ru-RU", { 
                day: "2-digit", 
                month: "2-digit", 
                year: "numeric" })}`;        
            }
        return date.toLocaleString("ru-RU", { 
            day: "2-digit", 
            month: "2-digit", 
            year: "numeric", 
            hour: "2-digit", 
            minute: "2-digit" });    
        }

    get datetime() {
        return this._datetime;
    }

    set datetime(value) {
        this._datetime = value;
        this._update();
    }

    get datetimetype() {
        return this._datetimetype;
    }

    set datetimetype(value) {
        this._datetimetype = window._enums.DateTimeType_Full[+value];
        this.inputElem.value = this.getCurrentDateTime();
        if(this.dp) {
            this.dp.destroy();
        }
        this.initDatepicker();
    }

    getCurrentDateTime() {
        const now = new Date();
        const formatNumber = (num) => num.toString().padStart(2, '0');
        const day = formatNumber(now.getDate());
        const month = formatNumber(now.getMonth() + 1);
        const year = now.getFullYear();
        const hours = formatNumber(now.getHours());
        const minutes = formatNumber(now.getMinutes());
    
        if (this._datetimetype === 0) {
            return `${day}.${month}.${year}`;
        } else if (this._datetimetype === 2) {
            return `${hours}:${minutes}, ${day}.${month}.${year}`;
        }
    
        return `${day}.${month}.${year} ${hours}:${minutes}`;
    }

    updateButtons() {
        this.buttonsContainer = document.querySelector(".air-datepicker-buttons");
        this.todayButton = this.buttonsContainer.querySelector(".air-datepicker-button:nth-child(1)");
        this.applyButton = this.buttonsContainer.querySelector(".air-datepicker-button:nth-child(2)");
        this.space = this.buttonsContainer.querySelector(".air-datepicker-button:nth-child(3)");
        this.cancelButton = this.buttonsContainer.querySelector(".air-datepicker-button:nth-child(4)");
        this.buttonsContainer.style.display = "inline-block";
        this.todayButton.setAttribute("title", "Вернуться к текущей дате и времени")
        this.todayButton.style.width = "100%";
        this.todayButton.style.marginBottom = '5px';
        this.applyButton.style.background = "#0d99ff";
        this.applyButton.style.width = "47%";
        this.applyButton.style.color = "white";
        this.cancelButton.style.background = "#0d99ff";
        this.cancelButton.style.width = "47%";
        this.cancelButton.style.color = "white";
        this.space.style.width = '4%';
    }

    _setNewDateTime(date) {
        if (!date) {
            let now = new Date();
            date = {
                yyyy: now.getFullYear(),
                MM: now.getMonth() + 1,
                dd: now.getDate(),
                HH: now.getHours(),
                mm: now.getMinutes()
            };
        }
        let timestamp = new Date(
            date.yyyy || 1971,
            (date.MM ? date.MM - 1 : 0),
            date.dd || 1,
            date.HH || 0,
            date.mm || 0
        ).getTime();
        
        this.SetParameter("datetime", timestamp, this.force);
    }

    initDatepicker() {
        this.dp = new AirDatepicker(this.inputElem, {
            locale: locale,
            autoClose: false,
            view: "days",
            timepicker: this._datetimetype !== 0,
            isMobile: false,

            onSelect: ({ date }) => {
                if (!date) return;
                let selectedDate = new Date(date);    
                let formattedText;
                formattedText = this.formatDate(selectedDate)
                this.inputElem.value = formattedText;
            },
            onShow: (dp) => {
                setTimeout(() => {
                    let rect = this.inputElem.getBoundingClientRect();
                    let spaceBelow = document.documentElement.clientHeight - rect.bottom;
                    let dpElem = document.querySelector(".air-datepicker");
                    if (dpElem) {
                        this.calendarHeight = dpElem.getBoundingClientRect().height
                        let position = (spaceBelow - 20) < this.calendarHeight ? "top center" : "bottom center";
                        if (position === "top center") {
                            dpElem.style.top = `${rect.top - this.calendarHeight - 15}px`;
                        } else {
                            dpElem.style.top = `${rect.bottom + 15}px`;
                        }
                    }
                    this.updateButtons();
                }, 0);
            },
            onHide: (dp) => {
                this.saveClick()
            },
            buttons: [
                {
                    content: () => `
                            <div class="main-pen-icon">${i18next.t('trend_timeInterval_today')}</div>`,
                    onClick: (dp) => dp.selectDate(new Date(), { updateTime: true })
                },
                {
                    content: () => `<div>Применить</div>`,
                    className: "apply-btn",
                    onClick: (dp) => {
                        dp.hide();
                    }
                },
                {
                    content: () => `<div></div>`,
                },
                {
                    content: () => `<div>Отмена</div>`,
                    className: "cancel-btn",
                    onClick: (dp) => {
                        this.inputElem.value = this.originalValue;
                        dp.hide();
                    }
                },
            ],
        });
    }

    disconnectedCallback() {
        this.inputElem.removeEventListener("click", this.handleClick);
        super.disconnectedCallback();
    }
}